import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed, signinUserFront } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, patchRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getContactUs, successContactUs, failedContactUs, removeContactUs, getDashboardData } from '../slice/contactUsSlice';
import { getAppointment, successAppointment, failedAppointment, removeAppointment, getDashboardDataa } from '../slice/appointmentSlice';
import { getEnquire, successEnquire, failedEnquire, removeEnquire } from '../slice/enquireSlice';
import { addProduct, getProduct, updateProduct, successProduct, removeProduct, getOneProduct, searchProductByName } from '../slice/productSlice';
import { getGallery, successGallery, removeGallery, addGallery, updateGallery, getOneGallery, toggleGallery } from '../slice/gallerySlice';
import { getNumber, successNumber, removeNumber, addNumber, updateNumber, getOneNumber } from '../slice/guessingnumberSlice';
import { getMedia, successMedia, removeMedia, addMedia, updateMedia, getOneMedia } from '../slice/mediaSlice';
import { getBanner, successBanner, removeBanner, addBanner, updateBanner, getOneBanner, toggleBanner, failedBanner } from '../slice/bannerSlice';
import { getEvents, successEvents, removeEvents, addEvents, updateEvents, getOneEvents, toggleEvents, failedEvents } from '../slice/eventsSlice';
import { failedCareer, getCareer, removeCareer, successCareer } from 'slice/careerSlice';
import { getOurteam, successOurteam, removeOurteam, addOurteam, updateOurteam, getOneOurteam, failedOurteam } from 'slice/ourteamSlice';
import { getCustomer, successCustomer, removeCustomer, addCustomer, updateCustomer, getOneCustomer, searchByMobile } from '../slice/customerSlice';
import { addOrderListDB, getOrderListDB, getOrderDeatilsDB, successOrderListDB, failedOrderListDB, updateOrderListDB, getOrderListWithdrawelDB } from '../slice/orderSliceDB';
import { getLiveVideoRequest, getLiveVideoSuccess, getLiveVideoFail, addLiveVideoRequest, addLiveVideoSuccess, addLiveVideoFail, deleteLiveVideoRequest, deleteLiveVideoFail } from '../slice/liveVideoSlice';
import { updateOrderAPI } from './orderAPI/orderAPI';
import { getGamebidAPI, postGameWinningAPI } from './gamebid/gamebidAPI';
import { getGameBid, gameBidWinnerCheck } from '../slice/gamebidSlice';

// category section
import { addCategory, updateCategory, getCategory } from 'slice/categorySlice';
import { updateCategoryAPI, addCategoryFun, getCategoryFun  } from './categoryAPI/categoryAPI';


// Generator function
function* signinUser({ payload }) {
  try {
    // You can also export the axios call as a function.
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true, // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        message: 'something wrong try after sometime'
      }
    }
    if (response?.status == 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signinUserFrontFun({ payload }) {
  try {
    // You can also export the axios call as a function.
    let response = yield postRequest('login', payload, {
      withCredentials: true, // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        message: 'something wrong try after sometime'
      }
    }
    if (response?.status == 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getContactUsFun({ payload }) {
  try {
    const response = yield getRequest('contactus', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


function* getProductFun() {
  try {
    const response = yield getRequest('product');
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneProductFun({ payload }) {
  try {
    const response = yield getRequest(`product/one/${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('contactus', payload);
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeProductFun({ payload }) {
  try {
    const response = yield deleteRequest(`product/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('product', payload);
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addProductFun({ payload }) {
  try {
    //    let header = {

    //   headers: { "Content-Type": "multipart/form-data" }

    // }
    console.log(payload)
    const response = yield postRequest(`product`, payload);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* searchProductByNameFun({ payload }) {
  try {
    const response = yield getRequest(`product/search?product=${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateProductFun({ payload }) {
  try {
    let header = {
      headers: { "Content-Type": "multipart/form-data" }
    }
    const response = yield patchRequest(`product/${payload.id}`, payload.data, header);
    if (response?.status == 200) {
      const d = yield getRequest('product');
      yield put(successProduct(d?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Gallery Functions 
function* getGalleryFun() {
  try {
    const response = yield getRequest('gallery');
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`gallery/one/${payload}`);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`gallery/${payload}`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('gallery', payload);
      yield put(successGallery(listResponse?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest(`gallery`, payload);
    if (response?.status == 200 || response?.status == 201) {
      const listResponse = yield getRequest('gallery');
      yield put(successGallery(listResponse?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`gallery/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const listResponse = yield getRequest('gallery');
      yield put(successGallery(listResponse?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* toggleGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`gallery/${payload}/toggle`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('gallery');
      yield put(successGallery(listResponse?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// guessing number funtions

function* getNumberFun() {
  try {
    const response = yield getRequest('customer/gussingnumbers');

    if (response?.status == 200) {
      yield put(successNumber(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneNumberFun({ payload }) {
  try {
    const response = yield getRequest(`customer/gussingnumbers/one/${payload}`);
    if (response?.status == 200) {
      yield put(successNumber(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeNumberFun({ payload }) {
  try {
    const response = yield deleteRequest(`customer/gussingnumbers/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('customer/gussingnumbers', payload);
      yield put(successNumber(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addNumberFun({ payload }) {
  try {
    const response = yield postRequest(`customer/gussingnumbers`, payload);
    if (response?.status == 200) {
      yield put(successNumber(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateNumberFun({ payload }) {
  try {
    const response = yield patchRequest(`customer/gussingnumbers/${payload.id}`, payload.data);
    if (response?.status == 200) {
      const d = yield getRequest('customer/gussingnumbers');
      yield put(successNumber(d?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}
//Media Functions 
function* getMediaFun() {
  try {
    const response = yield getRequest('media');
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneMediaFun({ payload }) {
  try {
    const response = yield getRequest(`media/one/${payload}`);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeMediaFun({ payload }) {
  try {
    const response = yield deleteRequest(`media/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('media', payload);
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addMediaFun({ payload }) {
  try {
    const response = yield postRequest(`media`, payload);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateMediaFun({ payload }) {
  try {
    const response = yield patchRequest(`media/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successMedia(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}
// Enquire
function* getEnquireFun({ payload }) {
  try {
    const response = yield getRequest('enquire', payload, payload.header);
    if (response?.status == 200) {
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeEnquireFun({ payload }) {
  try {
    const response = yield deleteRequest(`enquire/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('enquire', payload);
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getCareerFun({ payload }) {
  try {
    const response = yield getRequest('career', payload);
    if (response?.status == 200) {
      yield put(successCareer(response?.data));
    } else {
      yield put(failedCareer(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeCareerFun({ payload }) {
  try {
    const response = yield deleteRequest(`career/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('career', payload);
      yield put(success(response?.data));
    } else {
      yield put(failedCareer(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}



//Banner Start
function* getBannerFun() {
  try {
    const response = yield getRequest('banner?all=true');
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneBannerFun({ payload }) {
  try {
    const response = yield getRequest(`banner/${payload}`);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeBannerFun({ payload }) {
  try {
    const response = yield deleteRequest(`banner/${payload}`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('banner?all=true');
      yield put(successBanner(listResponse?.data));
      toast.success('Banner deleted successfully!');
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to delete banner'));
      toast.error(response?.data?.message || 'Failed to delete banner');
    }
  } catch (error) {
    console.error('removeBannerFun error:', error);
    yield put(failedBanner(error?.message || 'Failed to delete banner'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to delete banner');
  }
}

function* addBannerFun({ payload }) {
  try {
    const formData = new FormData();
    if (payload.heading) formData.append('heading', payload.heading);
    if (payload.imageFile) formData.append('image', payload.imageFile);
    
    const header = { headers: { 'Content-Type': 'multipart/form-data' } };
    const response = yield postRequest(`banner`, formData, header);
    if (response?.status == 200 || response?.status == 201) {
      const listResponse = yield getRequest('banner?all=true');
      yield put(successBanner(listResponse?.data));
      toast.success('Banner added successfully!');
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to add banner'));
      toast.error(response?.data?.message || 'Failed to add banner');
    }
  } catch (error) {
    console.error('addBannerFun error:', error);
    yield put(failedBanner(error?.message || 'Failed to add banner'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to add banner');
  }
}

function* updateBannerFun({ payload }) {
  try {
    const formData = new FormData();
    if (payload.data.heading) formData.append('heading', payload.data.heading);
    if (payload.data.is_active !== undefined) formData.append('is_active', payload.data.is_active);
    if (payload.data.imageFile) formData.append('image', payload.data.imageFile);

    const header = { headers: { 'Content-Type': 'multipart/form-data' } };
    const response = yield patchRequest(`banner/${payload.id}`, formData, header);
    if (response?.status == 200) {
      const listResponse = yield getRequest('banner?all=true');
      yield put(successBanner(listResponse?.data));
      toast.success('Banner updated successfully!');
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to update banner'));
      toast.error(response?.data?.message || 'Failed to update banner');
    }
  } catch (error) {
    console.error('updateBannerFun error:', error);
    yield put(failedBanner(error?.message || 'Failed to update banner'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to update banner');
  }
}

function* toggleBannerFun({ payload }) {
  try {
    const response = yield patchRequest(`banner/${payload}/toggle`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('banner?all=true');
      yield put(successBanner(listResponse?.data));
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to toggle banner'));
      toast.error(response?.data?.message || 'Failed to toggle banner');
    }
  } catch (error) {
    console.error('toggleBannerFun error:', error);
    yield put(failedBanner(error?.message || 'Failed to toggle banner'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to toggle banner');
  }
}

//Banner End 

//Events Start
function* getEventsFun() {
  try {
    const response = yield getRequest('events?limit=1000');
    if (response?.status == 200) {
      yield put(successEvents(response?.data));
    } else {
      console.error('getEventsFun error:', response);
      toast.error(response?.data?.message || 'Failed to load events');
    }
  } catch (error) {
    console.error('getEventsFun error:', error);
    toast.error(error?.response?.data?.message || error?.message || 'Failed to load events');
  }
}

function* getOneEventFun({ payload }) {
  try {
    const response = yield getRequest(`events/${payload}`);
    if (response?.status == 200) {
      yield put(successEvents(response?.data));
    } else {
      console.error('getOneEventFun error:', response);
      toast.error(response?.data?.message || 'Failed to load event');
    }
  } catch (error) {
    console.error('getOneEventFun error:', error);
    toast.error(error?.response?.data?.message || error?.message || 'Failed to load event');
  }
}

function* removeEventFun({ payload }) {
  try {
    const response = yield deleteRequest(`events/${payload}`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('events?limit=1000');
      yield put(successEvents(listResponse?.data));
      toast.success('Event deleted successfully!');
    } else {
      console.error('removeEventFun error:', response);
      toast.error(response?.data?.message || 'Failed to delete event');
    }
  } catch (error) {
    console.error('removeEventFun error:', error);
    toast.error(error?.response?.data?.message || error?.message || 'Failed to delete event');
  }
}

function* addEventFun({ payload }) {
  try {
    const formData = new FormData();
    if (payload.heading) formData.append('heading', payload.heading);
    if (payload.sub_heading !== undefined) formData.append('sub_heading', payload.sub_heading);
    if (payload.is_active !== undefined) formData.append('is_active', payload.is_active);
    if (payload.image) formData.append('image', payload.image);
    if (payload.file) formData.append('file', payload.file);

    const response = yield postRequest(`events`, formData);
    if (response?.status == 200 || response?.status == 201) {
      const listResponse = yield getRequest('events?limit=1000');
      yield put(successEvents(listResponse?.data));
      toast.success('Event added successfully!');
    } else {
      console.error('addEventFun error:', response);
      yield put(failedEvents(response?.data?.message || 'Failed to add event'));
      toast.error(response?.data?.message || 'Failed to add event');
    }
  } catch (error) {
    console.error('addEventFun error:', error);
    yield put(failedEvents(error?.response?.data?.message || error?.message || 'Failed to add event'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to add event');
  }
}

function* updateEventFun({ payload }) {
  try {
    const formData = new FormData();
    if (payload.data.heading) formData.append('heading', payload.data.heading);
    if (payload.data.sub_heading !== undefined) formData.append('sub_heading', payload.data.sub_heading);
    if (payload.data.is_active !== undefined) formData.append('is_active', payload.data.is_active);
    if (payload.data.image) formData.append('image', payload.data.image);
    if (payload.data.file) formData.append('file', payload.data.file);

    const response = yield patchRequest(`events/${payload.id}`, formData);
    if (response?.status == 200) {
      const listResponse = yield getRequest('events?limit=1000');
      yield put(successEvents(listResponse?.data));
      toast.success('Event updated successfully!');
    } else {
      console.error('updateEventFun error:', response);
      yield put(failedEvents(response?.data?.message || 'Failed to update event'));
      toast.error(response?.data?.message || 'Failed to update event');
    }
  } catch (error) {
    console.error('updateEventFun error:', error);
    yield put(failedEvents(error?.response?.data?.message || error?.message || 'Failed to update event'));
    toast.error(error?.response?.data?.message || error?.message || 'Failed to update event');
  }
}

function* toggleEventFun({ payload }) {
  try {
    const response = yield patchRequest(`events/${payload}/toggle`);
    if (response?.status == 200) {
      const listResponse = yield getRequest('events?limit=1000');
      yield put(successEvents(listResponse?.data));
    } else {
      console.error('toggleEventFun error:', response);
      toast.error(response?.data?.message || 'Failed to toggle event');
    }
  } catch (error) {
    console.error('toggleEventFun error:', error);
    toast.error(error?.response?.data?.message || error?.message || 'Failed to toggle event');
  }
}

//Events End 


//Ourteam Start
function* getOurteamFun() {
  try {
    const response = yield getRequest('ourteam');
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneOurteamFun({ payload }) {
  try {
    const response = yield getRequest(`ourteam/one/${payload}`);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeOurteamFun({ payload }) {
  try {
    const response = yield deleteRequest(`ourteam/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('ourteam', payload);
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* addOurteamFun({ payload }) {
  try {
    const response = yield postRequest(`ourteam`, payload);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateOurteamFun({ payload }) {
  try {
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    const response = yield patchRequest(`ourteam/${payload.id}`, payload.data, header);
    if (response?.status == 200) {
      yield put(successOurteam(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

//Ourteam End 


// customer start
function* addCustomerFun({ payload }) {
  try {
    const response = yield postRequest(`customer`, payload);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}


function* getCustomerFun({ payload }) {
  try {
    const response = yield getRequest(`customer${payload ? `?id=${payload.id}&refer=true` : ''}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* removeCustomerFun({ payload }) {
  try {
    const response = yield deleteRequest(`customer/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('customer', payload);
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOneCustomerFun({ payload }) {
  try {
    const response = yield getRequest(`customer/one/${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* updateCustomerFun({ payload }) {
  try {
    let header = {
      'Content-Type': 'multipart/form-data'
    }
    const response = yield patchRequest(`customer/${payload.id}`, payload.data, header);
    const data = yield getRequest('customer');
    if (response?.status == 200) {
      yield put(successCustomer(data?.data));
    } else {
      yield put(failedOurteam(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* searchByMobileFun({ payload }) {
  try {
    const response = yield getRequest(`customer/search?name=${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// customer end

// order list DB start
function* addOrderListDBFun({ payload }) {
  try {
    const response = yield postRequest(`order`, payload);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderListDBFun({ payload }) {
  try {
    console.log('dfsdfsdfsdf sdfdsfdsf dsfsfdsfdsf.  111111111111', payload)
    const response = yield getRequest(`order${payload?.id ? `?fil=${payload?.id}` : ''}`);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderListWithdrawelDBFun() {
  try {
    const response = yield getRequest('order/withdrawal');
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

function* getOrderDeatilsDBFun({ payload }) {
  try {
    const response = yield getRequest(`order/order_details/${payload}`);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast('resposnse.message')
  }
}

// Fetch Appointments
function* getAppointmentFun({ payload }) {
  try {
    const response = yield getRequest('appointments', payload);
    if (response?.status == 200) {
      yield put(successAppointment(response?.data));
    } else {
      yield put(failedAppointment(response?.data));
      toast(response?.data?.message || 'Failed to fetch appointments');
    }
  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}

// Fetch Dashboard Data
function* getDashboardDataaFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successAppointment(response?.data));
    } else {
      yield put(failedAppointment(response?.data));
      toast(response?.data?.message || 'Failed to fetch dashboard data');
    }
  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}

// Remove Appointment
function* removeAppointmentFun({ payload }) {
  try {
    if (!payload) {
      throw new Error('Appointment ID is missing');
    }
    const deleteResponse = yield deleteRequest(`appointments/${payload}`);
    if (deleteResponse?.status >= 200 && deleteResponse?.status < 300) {
      yield getAppointmentFun({ payload })
      toast('Appointment deleted successfully');
    } else {
      // If delete failed, dispatch failure action and show the error toast
      yield put(failedAppointment(deleteResponse?.data));
      toast(deleteResponse?.data?.message || 'Failed to delete appointment');
    }

  } catch (error) {
    console.log(error);
    toast(error.response?.data?.message || error.message);
  }
}




// function* removeAppointmentFun({ payload }) {
//   try {
//     const deleteResponse = yield deleteRequest(`appointments/${payload}`);
//     if (deleteResponse?.status == 200) {
//       const appointmentsResponse = yield getRequest('appointments');
//       yield put(successAppointment(appointmentsResponse?.data));
//     } else {
//       yield put(failedAppointment(deleteResponse?.data));
//       toast(deleteResponse?.data?.message || 'Failed to delete appointment');
//     }
//   } catch (error) {
//     console.log(error);
//     toast(error.response?.data?.message || error.message);
//   }
// }



// appointemnt
// order list db end 


// Generator function
// Live Video Functions
function* getLiveVideoFun() {
  try {
    const response = yield getRequest('liveVideo');
    if (response?.status == 200) {
      yield put(getLiveVideoSuccess(response?.data));
    } else {
      yield put(getLiveVideoFail(response));
    }
  } catch (error) {
    console.log(error);
    yield put(getLiveVideoFail(error.message));
  }
}

function* addLiveVideoFun({ payload }) {
  try {
    const response = yield postRequest(`liveVideo`, payload);
    if (response?.status === 201 || response?.status === 200) {
      yield put(addLiveVideoSuccess());
      const d = yield getRequest('liveVideo');
      yield put(getLiveVideoSuccess(d?.data));
    } else {
      yield put(addLiveVideoFail(response?.data?.message || response?.statusText || "Something went wrong"));
    }
  } catch (error) {
    console.log(error);
    yield put(addLiveVideoFail(error.response?.data?.message || error.message));
  }
}

function* deleteLiveVideoFun({ payload }) {
  try {
    const response = yield deleteRequest(`liveVideo/${payload}`);
    if (response?.status == 200) {
      const d = yield getRequest('liveVideo');
      yield put(getLiveVideoSuccess(d?.data));
    } else {
      yield put(deleteLiveVideoFail(response));
    }
  } catch (error) {
    console.log(error);
    yield put(deleteLiveVideoFail(error.message));
  }
}

export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);

  // contact us
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(getDashboardData, getDashboardDataFun);
  yield takeLatest(removeContactUs, removeContactUsFun);

  // appointemnt
  yield takeLatest(getAppointment, getAppointmentFun);
  yield takeLatest(getDashboardDataa, getDashboardDataaFun);
  yield takeLatest(removeAppointment, removeAppointmentFun);

  //Enquire
  yield takeLatest(getEnquire, getEnquireFun);
  yield takeLatest(removeEnquire, removeEnquireFun);

  yield takeLatest(addProduct, addProductFun);
  yield takeLatest(getProduct, getProductFun);
  yield takeLatest(getOneProduct, getOneProductFun);
  yield takeLatest(searchProductByName, searchProductByNameFun);
  yield takeLatest(removeProduct, removeProductFun);
  yield takeLatest(updateProduct, updateProductFun);

  //gallery
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(getGallery, getGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);
  yield takeLatest(toggleGallery, toggleGalleryFun);

  // guessing number

  yield takeLatest(addNumber, addNumberFun);
  yield takeLatest(getNumber, getNumberFun);
  yield takeLatest(removeNumber, removeNumberFun);
  yield takeLatest(getOneNumber, getOneNumberFun);
  yield takeLatest(updateNumber, updateNumberFun);

  //media
  yield takeLatest(addMedia, addMediaFun);
  yield takeLatest(getMedia, getMediaFun);
  yield takeLatest(removeMedia, removeMediaFun);
  yield takeLatest(getOneMedia, getOneMediaFun);
  yield takeLatest(updateMedia, updateMediaFun);

  //Banner
  yield takeLatest(addBanner, addBannerFun);
  yield takeLatest(getBanner, getBannerFun);
  yield takeLatest(removeBanner, removeBannerFun);
  yield takeLatest(getOneBanner, getOneBannerFun);
  yield takeLatest(updateBanner, updateBannerFun);
  yield takeLatest(toggleBanner, toggleBannerFun);

  //Events
  yield takeLatest(addEvents, addEventFun);
  yield takeLatest(getEvents, getEventsFun);
  yield takeLatest(removeEvents, removeEventFun);
  yield takeLatest(getOneEvents, getOneEventFun);
  yield takeLatest(updateEvents, updateEventFun);
  yield takeLatest(toggleEvents, toggleEventFun);

  //Our Team
  yield takeLatest(addOurteam, addOurteamFun);
  yield takeLatest(getOurteam, getOurteamFun);
  yield takeLatest(removeOurteam, removeOurteamFun);
  yield takeLatest(getOneOurteam, getOneOurteamFun);
  yield takeLatest(updateOurteam, updateOurteamFun);

  // Career 
  yield takeLatest(getCareer, getCareerFun);
  yield takeLatest(removeCareer, removeCareerFun);

  //Customer
  yield takeLatest(addCustomer, addCustomerFun);
  yield takeLatest(getCustomer, getCustomerFun);
  yield takeLatest(removeCustomer, removeCustomerFun);
  yield takeLatest(getOneCustomer, getOneCustomerFun);
  yield takeLatest(updateCustomer, updateCustomerFun);
  yield takeLatest(searchByMobile, searchByMobileFun);

  yield takeLatest(getCareer, getCareerFun);
  yield takeLatest(removeCareer, removeCareerFun);

  // order DB
  yield takeLatest(addOrderListDB, addOrderListDBFun);
  yield takeLatest(getOrderListDB, getOrderListDBFun);
  yield takeLatest(getOrderListWithdrawelDB, getOrderListWithdrawelDBFun);
  yield takeLatest(getOrderDeatilsDB, getOrderDeatilsDBFun);
  yield takeLatest(updateOrderListDB, updateOrderAPI);

  //game bid
  yield takeLatest(getGameBid, getGamebidAPI);
  yield takeLatest(gameBidWinnerCheck, postGameWinningAPI);
  yield takeLatest(signinUserFront, signinUserFrontFun);

  // category
  yield takeLatest(addCategory, addCategoryFun);
  yield takeLatest(updateCategory, updateCategoryAPI);
  yield takeLatest(getCategory, getCategoryFun)

  // Live Video
  yield takeLatest(getLiveVideoRequest.type, getLiveVideoFun);
  yield takeLatest(addLiveVideoRequest.type, addLiveVideoFun);
  yield takeLatest(deleteLiveVideoRequest.type, deleteLiveVideoFun);

}